import Service from "layouts/services/Service";
import ProtectedRoute from "./ProtectedRoute";
import Manage from "layouts/services/Manage";

const ServiceRoutes = [
  {
    route: "services/edit/:productId",
    key: "ServiceEdit",
    component: <ProtectedRoute check="logout"><Service /></ProtectedRoute>
  },
  {
    route: "/services/manage/:pageNo",
    key: "manage-service",
    component: <ProtectedRoute check="logout"><Manage /></ProtectedRoute>
  }
  ];

export default ServiceRoutes;
